/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = {
  HELMET_AMORTIZE_PAGETITLE: 'calculators.helmet.amortize.pageTitle',
  HELMET_PAGETITLE_ERROR: 'calculators.helmet.pageTitle.error',
  HELMET_SECTIONTITLE: 'calculators.helmet.sectionTitle',
  HOME_CARD_CALCULATE_ARIALABEL: 'calculators.home.card.calculate.ariaLabel',
  HOME_CARD_CALCULATE_LINKLABEL: 'calculators.home.card.calculate.linkLabel',
  HOME_CARD_CALCULATE_TEXT: 'calculators.home.card.calculate.paragraph',
  HOME_CARD_CALCULATE_TITLE: 'calculators.home.card.calculate.heading',
  HOME_CARD_PAYOFF_LINKLABEL: 'calculators.home.card.payoff.linkLabel',
  HOME_CARD_PAYOFF_TEXT: 'calculators.home.card.payoff.paragraph',
  HOME_CARD_PAYOFF_TITLE: 'calculators.home.card.payoff.heading',
  HOME_TOPSECTION_TEXT: 'calculators.home.topSection.paragraph',
  HOME_TOPSECTION_TITLE: 'calculators.home.topSection.heading',
};

const enMessages = {
  [IDS.HELMET_AMORTIZE_PAGETITLE]: 'Explore Payment Adjustments',
  [IDS.HELMET_PAGETITLE_ERROR]: 'Error',
  [IDS.HELMET_SECTIONTITLE]: 'Calculators',
  // Calculators Home Cards
  [IDS.HOME_CARD_CALCULATE_ARIALABEL]: 'Calculate payoff',
  [IDS.HOME_CARD_CALCULATE_LINKLABEL]: 'Calculate',
  [IDS.HOME_CARD_CALCULATE_TEXT]: 'Estimate how much you can save on interest by making extra payments.',
  [IDS.HOME_CARD_CALCULATE_TITLE]: 'Payoff your loan early',
  [IDS.HOME_CARD_PAYOFF_LINKLABEL]: 'Request Statement',
  [IDS.HOME_CARD_PAYOFF_TEXT]: 'Request online payoff statements and view past statements.',
  [IDS.HOME_CARD_PAYOFF_TITLE]: 'Request a payoff statement',
  // Calculators Home Top Section
  [IDS.HOME_TOPSECTION_TEXT]: 'Our calculators can help you see how small changes could make a big difference.',
  [IDS.HOME_TOPSECTION_TITLE]: 'Explore ways to pay off your loan faster',
};

const enMurabahaMessages = {
  ...enMessages,
  // Calculators Home Cards
  [IDS.HOME_CARD_CALCULATE_TEXT]: 'Estimate how much you can save on profit by making extra payments.',
  [IDS.HOME_CARD_CALCULATE_TITLE]: 'Payoff your Murabaha Financing Transaction early',
  [IDS.HOME_CARD_PAYOFF_TEXT]: 'Request online Discounted Murabaha debt/payoff statements and view past statements.',
  [IDS.HOME_CARD_PAYOFF_TITLE]: 'Request a Discounted Murabaha debt/payoff statement',
  // Calculators Home Top Section
  [IDS.HOME_TOPSECTION_TITLE]: 'Explore ways to pay off your Murabaha Financing Transaction faster',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
